requirejs.config({
    baseUrl: "app",
    packages: [{
        name: 'momentjs', // date and time lib
        location: '../lib/moment',
        main: 'moment'
    }],
    /**
     * Paths to lib dependencies.
     *
     * USE non-minified files where possible as they will be minified (and
     * optimized via uglify) on release build (r.js)
     */
    paths: {
        "jquery": "../lib/jquery/dist/jquery",
        "bootstrap": "../lib/bootstrap/dist/js/bootstrap",
        "underscore": "../lib/underscore/underscore",
        "text": "../lib/text/text",
        "mustache": "../lib/mustache.js/mustache", // Minimal templating with {{mustaches}}
        "colorpicker": "../lib/bootstrap-colorpicker/dist/js/bootstrap-colorpicker",
        "chartjs": "../lib/chart.js/dist/Chart",
        "sliderbar": "../lib/seiyria-bootstrap-slider/dist/bootstrap-slider",
        "selectpicker": "../lib/bootstrap-select/dist/js/bootstrap-select", // TODO Swap for selectize completely?
        "bootbox": "../lib/bootbox.js/bootbox", // Bottstrap modal
        "validate": "../lib/validate/validate", // validators lib used by models
        "color": "../lib/color/one-color",
        "rubaxa-sortable": "../lib/Sortable/Sortable", // drag'n'drop lib
        "cropper": "../lib/cropper/dist/cropper", // image resize/crop lib
        "nprogress": "../lib/nprogress/nprogress",
        'quantities': '../lib/js-quantities/build/quantities',
        'markdown': '../lib/marked/lib/marked',
        "jquery-easing": "../lib/jquery-easing/jquery.easing",

        // backbone and its plugins
        "backbone": "../lib/backbone/backbone",
        "epoxy": "../lib/backbone.epoxy/backbone.epoxy", // Elegant Data Binding for Backbone
        "backbone.paginator": "../lib/backbone.paginator/lib/backbone.paginator", // paginated collections
        "backbone.session": "../lib/backbone-session/backbone-session",

        // Editor (WYSIWYG)
        "summernote": "../lib/summernote/dist/summernote",

        // datepicker
        "bootstrap-datepicker": "../lib/bootstrap-datepicker/js/bootstrap-datepicker",
        "bootstrap-datepicker-fr": "../lib/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr",

        // selectize
        "sifter": "../lib/sifter/sifter", //
        "microplugin": "../lib/microplugin/src/microplugin",
        "selectize": "../lib/selectize/dist/js/standalone/selectize",

        // "es5-shim": "../lib/es5-shim/es5-shim", // monkey-patch a JavaScript context to contain all EcmaScript 5 methods
        // "es6-shim": "../lib/es6-shim/es6-shim", // Provides compatibility shims so that legacy JavaScript engines behave as closely as possible to ECMAScript 6 (Harmony).

        // translation ../lib
        "i18next": "../lib/i18next/i18next",
        "i18nextXHRBackend": "../lib/i18next-xhr-backend/i18nextXHRBackend.min",
        "i18nextLocizeBackend": "../lib/i18next-locize-backend/i18nextLocizeBackend",
        "i18nextLocalStorageCache": "../lib/i18next-localstorage-cache/i18nextLocalStorageCache",
        // toastr notifications
        "toastr": "../lib/toastr/toastr",

        // jspdf
        "jspdf": "../lib/jspdf/dist/jspdf.min",
        "html2pdf": "../lib/html2pdf.js/dist/html2pdf.bundle.min",

        // shims
        "moment": "src/shim/moment",
        "datepicker": "src/shim/bootstrap-datepicker",

        // custom
        "utils": "services/utils",
        "backbone.extension": "src/plugins/backbone.extension",
        "backbone.validators": "src/plugins/backbone.validators",
        "jquery.extension": "src/plugins/jquery.extension",
        "epoxy.extension": "src/plugins/epoxy.extension",
        "sortable": "src/plugins/sortable.extension", // drag'n'drop

        // debug
        "debug": "src/debug",

        // path
        "assets": "../assets",

    },
    map: {

        // since, when making a build with r.js, shims only work with non-AMD
        // modules, we're forced to map basic dependencies to our stuff which
        // require other plugins that are never required and are just adding
        // themselves to Backbone or Mustache for example.
        "*": {
            "backbone": "src/shim/backbone.plugins",
            "mustache": "src/plugins/mustache.extension",
            "bootbox": "src/plugins/bootbox.extension",
            "epoxy": "src/plugins/epoxy.extension",
            "jquery": "src/shim/jquery",
        },
        "epoxy": { "backbone": "src/shim/backbone", },
        "backbone.validators": { "backbone": "backbone", },
        "backbone.extension": { "backbone": "backbone", },
        "backbone.paginator": { "backbone": "backbone", },

        "src/plugins/bootbox.extension": { "bootbox": "bootbox" },
        "src/plugins/mustache.extension": { "mustache": "mustache", },
        "src/shim/backbone": { "backbone": "backbone" },
        "src/shim/jquery": { "jquery": "jquery" },
        "src/plugins/jquery.extension": { "jquery": "jquery" },
        "src/plugins/epoxy.extension": { "epoxy": "epoxy" },
    },
    shim: {
        "jquery": { exports: "jQuery" },
        "selectpicker": { deps: ['jquery'] },
        "summernote": { deps: ['jquery'] },
        "bootstrap-datepicker-fr": {
            deps: ["bootstrap-datepicker"],
            exports: "$.fn.datepicker.dates.fr",
        },
        "selectize": { deps: ["jquery"], },

        "toastr": { deps: ['jquery'] },

        "bootbox": { deps: ['bootstrap'] },

        "jquery.extension": { deps: ["jquery"] },

        "i18next": { deps: ['jquery', 'i18nextXHRBackend', 'i18nextLocizeBackend', 'i18nextLocalStorageCache'] },

        "app": {
            deps: [
                "epoxy",
                "selectize",
                "backbone.paginator",
                "i18next",
            ]
        },
    },

    // starts the app
    deps: [
        "app",
        "services/i18n",
    ]
});

define("main", function(){});

